import { CSSProperties } from 'react';
import { WelcomePopupComponent } from '../welcome-popup.component';
import { TranslationComponent } from '../translation.component';
import { Color, Size } from '@vivli/shared/theme';
import { ButtonView } from '@vivli/shared/views';
import { DTIWelcomeModal } from '@vivli/shared/infrastructure/constants';

const infoTextStyle = {
    fontSize: Size.FontSize.Large,
    lineHeight: '1.4',
    fontFamily: 'Verdana, sans-serif'
};

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    backgroundColor: Color.VIVLI_DARK_BLUE,
    color: Color.WHITE,
    minWidth: 300,
    borderRadius: 15,
    textAlign: 'left'
};

const headerStyle: CSSProperties = {
    paddingBottom: Size.PADDING * 2,
    paddingLeft: Size.PADDING * 2,
    paddingRight: Size.PADDING * 2,
    paddingTop: Size.PADDING * 2,
    borderBottom: '1px solid white',
    fontSize: Size.FontSize.Larger,
    alignContent: 'center'
};

const bodyContainerStyle: CSSProperties = {
    paddingBottom: Size.PADDING * 2,
    paddingLeft: Size.PADDING * 2,
    paddingRight: Size.PADDING * 2,
    paddingTop: Size.PADDING * 2,
    fontSize: Size.FontSize.Medium
};

const bodyStyle: CSSProperties = {
    display: 'flex',
    backgroundColor: 'white',
    paddingBottom: Size.PADDING,
    paddingLeft: Size.PADDING,
    paddingRight: Size.PADDING,
    paddingTop: Size.PADDING,
    color: 'black',
    overflowY: 'scroll',
    height: 310,
    flexDirection: 'column'
};

const buttonContainerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '20px'
};

const buttonStyle: CSSProperties = {
    backgroundColor: Color.VIVLI_RED
};

export const WelcomeModalComponent = ({ onClose }) => {
    const handleClose = () => {
        onClose && onClose();
    };

    return (
        <div style={containerStyle}>
            <div style={headerStyle} data-test-id="welcome_modal_header">
                Welcome to the <TranslationComponent>Vivli</TranslationComponent> platform
            </div>
            <div style={bodyContainerStyle}>
                <div style={bodyStyle} className="scrolly">
                    <span style={infoTextStyle} data-test-id="welcome_modal_text">
                        <WelcomePopupComponent />
                    </span>
                </div>

                <div style={buttonContainerStyle}>
                    <ButtonView style={buttonStyle} onClick={handleClose} dataId={DTIWelcomeModal.WelcomeModalButtonClose}>
                        Close
                    </ButtonView>
                </div>
            </div>
        </div>
    );
};
